import { render, staticRenderFns } from "./request-kyc.vue?vue&type=template&id=27e45a1f&"
import script from "./request-kyc.vue?vue&type=script&lang=js&"
export * from "./request-kyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports